import { Routes, Route, Navigate } from 'react-router-dom';
import StudentPage from 'src/components/StudentPage/StudentPage';
import { RoleTypes } from 'src/models/roles';
import SigningFormPage from 'src/components/SigningForm/SigningFormPage';
import FormPage from '../Student/StudentForms/FormPage/FormPage';
import SupervisorPage from './TeacherClass/SupervisorPage/SupervisorPage';
import TeacherClass from './TeacherClass/TeacherClass';
import TeacherClasses from './TeacherClasses/TeacherClasses';
import PrivacyPolicyPage from '../Main/PrivacyPolicy/PrivacyPolicyPage';

const TeacherRouter = () => (
  <Routes>
    <Route path="" element={<TeacherClasses />} />
    <Route path="class">
      <Route path=":classId" element={<TeacherClass />} />
      <Route
        path=":classId/student/:userId"
        element={<StudentPage activeRole={RoleTypes.Teacher} />}
      />
      <Route path=":classId/advisor/:userId" element={<SupervisorPage />} />
      <Route
        path=":classId/student/:studentUserId/form/:formId/assignment/:assignmentId"
        element={<FormPage />}
      />
      <Route
        path=":classId/student/:studentUserId/signingform"
        element={<SigningFormPage />}
      />
    </Route>
    <Route path="form/:formId" element={<FormPage />} />
    <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);
export default TeacherRouter;
